import React from 'react'
import { classnames } from '@halo/_utils/classnames'
import SkeletonBlock, { SkeletonBlockProps } from '@halo/components/skeleton-block/skeleton-block'
import NoneValue from '@halo/components/none-value/none-value'
import { isNullOrUndefined } from '@halo/_utils/is-null-or-undefined'

interface IFormLayoutRowProps {
    className?: string
    labelClassName?: string
    valueClassName?: string
    subClassName?: string
    label: React.ReactNode
    value: React.ReactNode
    sub?: React.ReactNode
    loading?: boolean
    skeleton?: SkeletonBlockProps
}

const FormLayoutRow: React.FunctionComponent<IFormLayoutRowProps> = ({ label, value, sub, loading, ...props }) => (
    <div className={classnames('form-layout-row', props.className)}>
        <div className={classnames('form-layout-row-label', props.labelClassName)}>{label}</div>
        <div className={classnames('form-layout-row-value', props.valueClassName)}>
            {loading ? <SkeletonBlock {...props.skeleton} /> : isNullOrUndefined(value) ? <NoneValue /> : value}
        </div>
        {sub && <div className={classnames('form-layout-row-sub', props.subClassName)}>{sub}</div>}
    </div>
)

export default FormLayoutRow
